<template>
    <div id="app">
        <TopBar />
        <router-view></router-view>
        <div></div>
    </div>
</template>

<script>
    import TopBar from "./components/TopBar";

    export default {
        name: 'App',
        components: {
            TopBar
        }
    }
</script>

<style>
    * {
        padding: 0;
        margin: 0;
        -webkit-tap-highlight-color: transparent;
        outline: none;
    }

    html, body {
        height: 100vh;
        width: 100vw;
        overflow-x: hidden;
    }
    #app {
        font-family: "Fira Code", monospace;
        font-size: 18px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #333333;
        background-color: #203A43;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 16px;
        padding-right: 16px;

        min-height: 100vh;
    }
</style>
